import { PlainFunction } from '../types/interfaces';

let timeout;

export const funcExecuteReset = (func: PlainFunction, minTimeout = 350) => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    func();
  }, minTimeout);
};
